import { useTranslation } from 'react-i18next';
import { Wrapper, NavigationButton, NavigationIcon } from './Navigation.styles';
import leftNavigationBg from '../../../../../../icons/left-navigation.svg';
import rightNavigationBg from '../../../../../../icons/right-navigation.svg';

interface NavigationProp {
  onNext: () => void;
  onPrevious: () => void;
  isDisableNext: boolean;
  isDisablePrevious: boolean;
}

const Navigation = ({
  onNext,
  onPrevious,
  isDisableNext,
  isDisablePrevious,
  ...props
}: NavigationProp): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Wrapper {...props}>
      <NavigationButton
        aria-disabled={isDisablePrevious}
        onClick={isDisablePrevious ? undefined : onPrevious}
        aria-label={t('ALT_TEXT_PREVIOUS_SLIDE')}
      >
        <NavigationIcon src={leftNavigationBg} aria-hidden />
      </NavigationButton>
      <NavigationButton
        aria-disabled={isDisableNext}
        onClick={isDisableNext ? undefined : onNext}
        aria-label={t('ALT_TEXT_NEXT_SLIDE')}
      >
        <NavigationIcon src={rightNavigationBg} aria-hidden />
      </NavigationButton>
    </Wrapper>
  );
};

export { Navigation, NavigationProp };
